/* eslint-disable react/jsx-wrap-multilines */
import React, { ChangeEvent } from 'react';
import cc from 'classnames';
import {
  FormControl, InputLabel, TextFieldProps, Input, InputProps, InputAdornment, IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import noop from 'utils/noop';

import styles from './TableInput.module.css';

import SearchIcon from 'assets/icons/table-icons/search.svg';

interface ITableInput {
  className?: string;
  name: string;
  label: string;
  onChange?: (e: ChangeEvent<{ name?: string | undefined; value: unknown }>) => void;
  onClickClear?: (name: string) => void;
  showIcon?: boolean;
  fullWidth?: boolean;
}

const TableInput = ({
  name,
  label,
  className,
  onClickClear,
  showIcon,
  fullWidth,
  onChange = noop,
  ...props
}: TextFieldProps & InputProps & ITableInput) => {
  const labelContent = () => {
    if (showIcon && !props.value) {
      return (
        <>
          <span className="searchIcon">
            <img src={SearchIcon} alt="search icon" />
          </span>
          {label}
        </>
      );
    }
    return label;
  };
  return (
    <FormControl
      variant="filled"
      fullWidth={fullWidth}
      className={cc(styles.input, { [styles.showIcon]: showIcon }, className)}
    >
      <InputLabel>{labelContent()}</InputLabel>
      <Input
        name={name}
        disableUnderline
        onChange={(e) => onChange(e)}
        InputProps={{
          endAdornment: (
            props.value && onClickClear && (
              <InputAdornment position="end">
                <IconButton onClick={() => onClickClear(name)} size="small">
                  <Clear style={{ fontSize: '20px' }} />
                </IconButton>
              </InputAdornment>
            )),
        }}
        {...props}
      />
    </FormControl>
  );
};

export default TableInput;
